module.exports = __webpack_public_path__ + "img/ggg.f84658c8.jpg";